import { ConfidenceCard } from "./types";

export const CONFIDENCE_CARDS: readonly ConfidenceCard[] = [
  {
    label: "High confidence",
    description: "Fresh data from connected accounts. VAT calculated from recent transactions.",
    variant: "high",
  },
  {
    label: "Medium confidence",
    description: "Data is a few days old or some transactions could not be categorised.",
    variant: "medium",
  },
  {
    label: "Low confidence",
    description: "Bank connection is stale or VAT estimate relies on assumptions.",
    variant: "low",
  },
] as const;
